/*****************************************************
Alexander Self
12/17/17
HeadCount: Displays a headcount by department by date
*****************************************************/
import React from 'react';

const MissingTimesheet = ({ empsWOTS, fetchMissingTimesheets }) => {
  return (
    <ul className="collection with-header">
      <li className="collection-item avatar">
        <i className="material-icons circle red">assignment_late</i>
        <span className="card-title grey-text text-darken-4">Missing Timesheets <b>{empsWOTS.date}</b></span>

          <form onSubmit={(e) => e.preventDefault()} id="headcount-search">
            <input id="missingTimesheet-date" type="date" pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}" />
            <button id="missingTimesheet-date-btn" className="btn btn-flat" onClick={() => fetchMissingTimesheets(document.getElementById('missingTimesheet-date').value)}>Fetch</button>
          </form>
        <span className="leaderInfo">Total Missing Timesheets: <b>{empsWOTS.total} people</b></span><br />
      </li>
      <div className="leaderBoard">
        {
          empsWOTS.data.map((h, i) => (
            <li className="collection-item avatar" key={h.key}>
              <div className="row">
                <div className="col s10 m10 l10 xl10 leaderInfo">

                  <span className="flow-text">{h.data ? `${h.data[0].manager.firstName} ${h.data[0].manager.lastName}` : ''}</span><br />
                  <p className="flow-text">
                    Count: <b>{h.data.length}</b><br />
                  </p><hr />
                  <div>
                  <details>
                    <summary>Employees</summary>
                    <table className="highlight bordered responsive-table centered">
                      <thead>
                        <tr>
                          <th>EID</th>
                          <th>Name</th>
                          <th>Location</th>
                          <th>Department</th>
                          <th>Position Type</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          h.data.map((e) => {
                            return (
                              <tr key={e.eid}>
                                <td>{ e.eid === null ? '' : e.eid }</td>
                                <td>{ e.firstName === null ? '' : e.firstName } { e.lastName === null ? '' : e.lastName }</td>
                                <td>{ e.location }</td>
                                <td>{ e.department }</td>
                                <td>{ e.positionType }</td>
                              </tr>
                            )
                          })
                        }
                      </tbody>
                    </table>
                  </details>
                  </div>
                </div>
              </div>
            </li>
          ))
        }
      </div>
    </ul>
  );
}

export default MissingTimesheet;



































/* END */



// WEBPACK FOOTER //
// ./src/components/dashboard/dashboard_missingTimesheet.js